import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Dropdown,
  Checkbox,
  Radio,
  Input,
  TextArea,
  Button,
  Segment,
  Icon
} from 'semantic-ui-react'

const CardORDetailUX = (props: any) => {
    return(
      <div
        id="CardORDetail"
        style={{width:"100%",}}>
        <div
          className="ui form"
          id="CardORDetailUX-div-1">
          
          <FormGroup
            id="CardORDetailUX-FormGroup-2"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-12"
              inline={true}
              style={{minWidth: "max-content"}}
              width={2}>
              <label
                id="CardORDetailUX-label-18"
                style={{fontWeight: "bold", margin: 0}}>
                {props.languageUX === "en" ? "Anesthesia Method" : "วิธีระงับความรู้สึก"}
              </label>
              <label
                id="CardORDetailUX-label-19"
                style={{color: "red"}}>
                *
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-13"
              inline={true}
              width={3}>
              <Dropdown
                fluid={true}
                id="CardORDetailUX-Dropdown-20"
                name="anesthesia_method"
                onChange={props.onChangeValue}
                options={props.anesthesiaMethodOptions || []}
                selection={true}
                style={{width: "100%"}}
                value={props.anesthesiaMethod || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-123"
              inline={true}
              style={{display: "flex", alignItems: "center"}}>
              <FormField
                className="required"
                id="CardORDetailUX-FormField-211"
                style={{minWidth: "max-content"}}>
                <label
                  id="CardORDetailUX-label-212"
                  style={{color: "#056EBD",}}>
                  {props.languageUX === "en" ? "Estimate time" : "Estimate time"}
                </label>
              </FormField>
              <Input
                fluid={true}
                id="CardORDetailUX-Input-132"
                name="estimate_operation_hour"
                onChange={props.onChangeValue}
                style={{ minWidth: "6rem", maxWidth: "6rem"}}
                type="number"
                value={props.estimateOperationHour || ""}>
              </Input>
              <label
                id="CardORDetailUX-label-208"
                style={{fontWeight: "normal",color: "#056EBD", marginLeft: "0.75rem", marginRight: "1.25rem"  }}>
                {props.languageUX === "en" ? "hr." : "ชั่วโมง"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-125"
              inline={true}
              style={{display: "flex", alignItems: "center"}}>
              <Input
                fluid={true}
                id="CardORDetailUX-Input-133"
                name="estimate_operation_minute"
                onChange={props.onChangeValue}
                style={{ minWidth: "6rem", maxWidth: "6rem"}}
                type="number"
                value={props.estimateOperationMinute || ""}>
              </Input>
              <label
                id="CardORDetailUX-label-205"
                style={{fontWeight: "normal",color: "#056EBD", minWidth: "max-content" }}>
                {props.languageUX === "en" ? "min" : "นาที"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-128"
              inline={true}
              width={5}>
              <label
                id="CardORDetailUX-label-203"
                style={{color: "#056EBD",width: "100%", maxWidth: "max-content"}}>
                {props.languageUX === "en" ? "Date of Surgery" : "วันที่ผ่าตัด"}
              </label>
              <div
                id="CardORDetailUX-div-136"
                style={{width: "100%"}}>
                {props.DateTextBox}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-3"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-118"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-25"
              inline={true}>
              <label
                id="CardORDetailUX-label-36"
                style={{color: "#056EBD",minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Start time" : "เวลา เริ่มต้น"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-26"
              inline={true}
              width={2}>
              <div
                id="CardORDetailUX-div-37"
                style={{width: "100%"}}>
                {props.StartTime}
              </div>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-27"
              inline={true}>
              <label
                id="CardORDetailUX-label-38"
                style={{color: "#056EBD", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "End time" : "เวลา สิ้นสุด"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-28"
              inline={true}
              width={2}>
              <div
                id="CardORDetailUX-div-39"
                style={{width: "100%"}}>
                {props.EndTime}
              </div>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-137"
              inline={true}>
              <label
                id="CardORDetailUX-label-141"
                style={{color: "#056EBD"}}>
                {props.languageUX === "en" ? "Location" : "สถานที่"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-138"
              inline={true}
              width={3}>
              <Dropdown
                disabled={props.config?.disableLocation || props.config?.allowedEdit || false}
                fluid={true}
                icon={null}
                id="CardORDetailUX-Dropdown-144"
                name="location"
                onChange={props.onChangeValue}
                options={props.orLocationOptions || []}
                selection={true}
                style={{width: "100%", ...(props.location === "" && { display: "none" } ) }}
                value={props.location || "ไปเลือกที่วันเวลาผ่าตัด"}>
              </Dropdown>
              <Input
                disabled={true}
                fluid={true}
                id="CardORDetailUX-Input-209"
                style={{width: "100%", ...(props.location !== "" && { display: "none" } ) }}
                value="ไปเลือกที่วันเวลาผ่าตัด">
              </Input>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-139"
              inline={true}>
              <label
                id="CardORDetailUX-label-142"
                style={{color: "#056EBD"}}>
                {props.languageUX === "en" ? "Room" : "ห้อง"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-140"
              inline={true}
              width={3}>
              <Dropdown
                disabled={props.config?.disabledRoom || props.config?.allowedEdit || false}
                fluid={true}
                icon={null}
                id="CardORDetailUX-Dropdown-143"
                name="operating_room"
                onChange={props.onChangeValue}
                options={props.operatingRoomOptions || []}
                selection={true}
                style={{width: "100%", ...(props.operatingRoom === "" && { display: "none" } ) }}
                value={props.operatingRoom || "ไปเลือกที่วันเวลาผ่าตัด"}>
              </Dropdown>
              <Input
                disabled={true}
                fluid={true}
                id="CardORDetailUX-Input-210"
                style={{width: "100%", ...(props.operatingRoom !== "" && { display: "none" } ) }}
                value="ไปเลือกที่วันเวลาผ่าตัด">
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-4"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-45"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-49"
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Procedure Type" : "ประเภทหัตถการ"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-46"
              inline={true}
              width={3}>
              <Dropdown
                fluid={true}
                id="CardORDetailUX-Dropdown-50"
                name="procedure_type"
                onChange={props.onChangeValue}
                options={props.procedureTypeOptions || []}
                selection={true}
                style={{width: "100%"}}
                value={props.procedureType || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-47"
              inline={true}
              style={{display: props.config?.hideProcedureChecklist?"none":""}}>
              <Checkbox
                checked={props.frozenSection || false}
                id="CardORDetailUX-Checkbox-51"
                label={props.languageUX === "en" ? "Sentinel lymph node biopsy & Frozen section" : "การตัดชิ้นเนื้อต่อมน้ำเหลืองหลัก & การตรวจชิ้นเนื้อแบบแช่เย็น"}
                name="frozen_section"
                onChange={props.onChangeValue}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-48"
              inline={true}
              style={{display: props.config?.hideProcedureChecklist?"none":""}}>
              <Checkbox
                checked={props.mammogram || false}
                id="CardORDetailUX-Checkbox-52"
                label={props.languageUX === "en" ? "Needle Localized; Mammogram" : "การวางเข็มชี้ตำแหน่ง; ด้วยแมมโมแกรม"}
                name="mammogram"
                onChange={props.onChangeValue}>
              </Checkbox>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-7"
            inline={true}>
            <FormField
              className="required"
              id="CardORDetailUX-FormField-85"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-92">
                {props.languageUX === "en" ? "Preoperative medications to stop" : "ยาที่ต้องหยุดก่อนผ่าตัด"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-86"
              inline={true}
              style={{_minWidth: "290px",minWidth: "max-content",gap:"10px"}}
              width={5}>
              <Radio
                checked={props.antiPlateletValue === props.ADM_FIBRINOLYTIC_USED.NO_DRUG}
                id="CardORDetailUX-Radio-94"
                label={props.languageUX === "en" ? "Not on medication" : "ไม่ได้ใช้ยา"}
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value:  props.ADM_FIBRINOLYTIC_USED.NO_DRUG, name: "anti_platelet_coagulant.value" })}
                style={{minWidth: "max-content"}}>
              </Radio>
              <Radio
                checked={props.antiPlateletValue === props.ADM_FIBRINOLYTIC_USED.CUT_DRUG}
                id="CardORDetailUX-Radio-169"
                label={props.languageUX === "en" ? "No need to stop medication" : "ไม่ต้องงด"}
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value:  props.ADM_FIBRINOLYTIC_USED.CUT_DRUG, name:"anti_platelet_coagulant.value"})}
                style={{minWidth: "max-content"}}>
              </Radio>
              <Radio
                checked={props.antiPlateletValue === props.ADM_FIBRINOLYTIC_USED.ANTI_PALETELET}
                id="CardORDetailUX-Radio-170"
                label={props.languageUX === "en" ? "Stop medication" : "งดใช้ยา"}
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value:  props.ADM_FIBRINOLYTIC_USED.ANTI_PALETELET, name:"anti_platelet_coagulant.value"})}
                style={{minWidth: "max-content"}}>
              </Radio>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-168"
              inline={true}
              width={7}>
              <Checkbox
                checked={props.antiPlateletCoagulant?.drug || false}
                id="CardORDetailUX-Checkbox-171"
                label={props.languageUX === "en" ? "Anti-Platelet/ Anti-Coagulant" : "Anti-Platelet/ Anti-Coagulant"}
                name="anti_platelet_coagulant.drug"
                onChange={props.onChangeValue}
                style={{width: "calc(100% - -3rem)", maxWidth: "max-content"}}>
              </Checkbox>
              <Radio
                checked={props.antiPlateletValue === props.ADM_FIBRINOLYTIC_USED.ANTI_PALETELET}
                id="CardORDetailUX-Radio-201"
                label="ใช้ Anti-Platelet/ Anti-Coagulant"
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value:  props.ADM_FIBRINOLYTIC_USED.ANTI_PALETELET, name:"anti_platelet_coagulant.value"})}
                style={{minWidth: "max-content", marginRight: "1rem", display: "none" }}>
              </Radio>
              <Input
                disabled={!props.antiPlateletCoagulant?.drug || false}
                fluid={true}
                id="CardORDetailUX-Input-178"
                name="anti_platelet_coagulant.remark"
                onChange={props.onChangeValue}
                style={{width:"100%"}}
                value={props.remark || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-90"
              inline={true}>
              <label
                id="CardORDetailUX-label-98"
                style={{minWidth: "max-content", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Stop medication from" : "งดใช้ยาตั้งแต่วันที่"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-91"
              inline={true}
              width={3}>
              <div
                id="CardORDetailUX-div-99"
                style={{width: "100%"}}>
                {props.DateTextBoxAntiPlatelet}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-222"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-223"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-225"
              inline={true}
              style={{_minWidth: "290px",minWidth: "max-content"}}
              width={5}>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-229"
              inline={true}
              width={7}>
              <Checkbox
                checked={props.antiPlateletCoagulant?.other_drug || false}
                id="CardORDetailUX-Checkbox-230"
                label={props.languageUX === "en" ? "Other Medications" : "ยาอื่น ๆ"}
                name="anti_platelet_coagulant.other_drug"
                onChange={props.onChangeValue}
                style={{width: "calc(100% - -3rem)", maxWidth: "max-content"}}>
              </Checkbox>
              <TextArea
                disabled={!props.antiPlateletCoagulant?.other_drug || false}
                id="CardORDetailUX-TextArea-237"
                name="anti_platelet_coagulant.other_drug_remark"
                onChange={props.onChangeValue}
                value={props.antiPlateletCoagulant?.other_drug_remark || ""}>
              </TextArea>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-233"
              inline={true}>
              <label
                id="CardORDetailUX-label-234"
                style={{minWidth: "max-content", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Stop medication from" : "งดใช้ยาตั้งแต่วันที่"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-235"
              inline={true}
              width={3}>
              <div
                id="CardORDetailUX-div-236"
                style={{width: "100%"}}>
                {props.DateTextBoxAntiPlateletOther}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-213"
            inline={true}>
            <FormField
              className="required"
              id="CardORDetailUX-FormField-214"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-215"
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "NPO" : "NPO"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-238"
              inline={true}
              style={{_minWidth: "290px",minWidth: "max-content", gap:"10px"}}
              width={5}>
              <Radio
                checked={props.antiPlateletCoagulant?.npo === "NO_NPO"}
                id="CardORDetailUX-Radio-239"
                label={props.languageUX === "en" ? "No NPO required" : "ไม่ต้อง NPO"}
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value: "NO_NPO", name: "anti_platelet_coagulant.npo" })}
                style={{minWidth: "max-content"}}>
              </Radio>
              <Radio
                checked={props.antiPlateletCoagulant?.npo === "NPO"}
                id="CardORDetailUX-Radio-240"
                label={props.languageUX === "en" ? "Full NPO" : "NPO ทั้งหมด"}
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value: "NPO", name: "anti_platelet_coagulant.npo" })}
                style={{minWidth: "max-content"}}>
              </Radio>
              <Radio
                checked={props.antiPlateletCoagulant?.npo === "NO_NPO_DRUG"}
                id="CardORDetailUX-Radio-241"
                label={props.languageUX === "en" ? "NPO except medications" : "NPO ยกเว้น ยา"}
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value: "NO_NPO_DRUG", name: "anti_platelet_coagulant.npo" })}
                style={{minWidth: "max-content"}}>
              </Radio>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-242"
              inline={true}>
              <label
                id="CardORDetailUX-label-243"
                style={{minWidth: "max-content", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Stop from" : "งดตั้งแต่วันที่"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-244"
              inline={true}
              width={3}>
              <div
                id="CardORDetailUX-div-245"
                style={{width: "100%"}}>
                {props.DateTextBoxNPO}
              </div>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-246"
              inline={true}>
              <label
                id="CardORDetailUX-label-247"
                style={{minWidth: "max-content", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Time" : "เวลา"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-248"
              inline={true}
              width={3}>
              <div
                id="CardORDetailUX-div-249"
                style={{width: "100%"}}>
                {props.TimeTextBoxNPO}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-172"
            inline={true}
            style={{display: "none"}}>
            <FormField
              id="CardORDetailUX-FormField-173"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-176">
                
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-174"
              inline={true}
              style={{minWidth: "290px"}}>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-175"
              style={{alignItems:"baseline"}}
              width={5}>
              <Checkbox
                checked={props.otherPreOpMeds?.value || false}
                id="CardORDetailUX-Checkbox-177"
                label="ยาอื่นๆ"
                name="other_pre_op_meds.value"
                onChange={props.onChangeValue}
                style={{minWidth: "max-content"}}>
              </Checkbox>
              <TextArea
                disabled={!props.otherPreOpMeds?.value}
                id="CardORDetailUX-TextArea-179"
                name="other_pre_op_meds.remark"
                onChange={props.onChangeValue}
                rows={2}
                value={props.otherPreOpMeds?.remark || ""}>
              </TextArea>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-180"
              inline={true}>
              <label
                id="CardORDetailUX-label-182"
                style={{minWidth: "max-content", fontWeight: "normal"}}>
                งดใช้ยาตั้งแต่วันที่
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-181"
              inline={true}>
              <div
                id="CardORDetailUX-div-183"
                style={{width: "100%"}}>
                {props.DateTextBoxOtherDrug}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-184"
            inline={true}
            style={{display: "none"}}>
            <FormField
              className="required"
              id="CardORDetailUX-FormField-185"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-189">
                NPO
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-186"
              inline={true}>
              <Radio
                checked={props.npoValue === props.NOTHING_THROUGH_MOUTH?.NO_NPO}
                id="CardORDetailUX-Radio-190"
                label="ไม่ต้อง NPO"
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value:  props.NOTHING_THROUGH_MOUTH?.NO_NPO, name: "npo.value" })}>
              </Radio>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-187"
              inline={true}>
              <Radio
                checked={props.npoValue === props.NOTHING_THROUGH_MOUTH?.NPO_ALL}
                id="CardORDetailUX-Radio-191"
                label="NPO ทั้งหมด"
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value:  props.NOTHING_THROUGH_MOUTH?.NPO_ALL, name: "npo.value" })}>
              </Radio>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-188"
              inline={true}>
              <Radio
                checked={props.npoValue === props.NOTHING_THROUGH_MOUTH?.EXCEPT_MEDS}
                id="CardORDetailUX-Radio-192"
                label="NPO ยกเว้น ยา"
                onChange={(e: any, v: any)=> props.onChangeValue(e, { value:  props.NOTHING_THROUGH_MOUTH?.EXCEPT_MEDS, name: "npo.value" })}>
              </Radio>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-193"
              inline={true}>
              <label
                id="CardORDetailUX-label-197"
                style={{minWidth: "max-content", fontWeight: "normal"}}>
                งดตั้งแต่วันที่
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-194"
              inline={true}>
              <div
                id="CardORDetailUX-div-199"
                style={{width: "100%"}}>
                {props.DateTextBoxNPO}
              </div>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-195"
              inline={true}>
              <label
                id="CardORDetailUX-label-198"
                style={{minWidth: "max-content", fontWeight: "normal"}}>
                เวลา
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-196"
              inline={true}
              width={2}>
              <div
                id="CardORDetailUX-div-200"
                style={{width: "100%"}}>
                {props.TimeNPO}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-8"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-100"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-104">
                {props.languageUX === "en" ? "Contrast Media" : "Contrast Media"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-101"
              inline={true}
              width={5}>
              <Dropdown
                id="CardORDetailUX-Dropdown-106"
                name="contrast_media"
                onChange={props.onChangeValue}
                options={props.cmOptions || {}}
                selection={true}
                style={{width: "100%"}}
                value={props.contrastMedia || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-102"
              inline={true}>
              <label
                id="CardORDetailUX-label-105">
                {props.languageUX === "en" ? "ASA PS" : "ASA PS"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-103"
              inline={true}
              width={6}>
              <Dropdown
                id="CardORDetailUX-Dropdown-107"
                name="asa_class"
                onChange={props.onChangeValue}
                options={props.asaClassOptions || []}
                selection={true}
                style={{width: "100%"}}
                value={props.asaClass || ""}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-321"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-322"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-323">
                {props.languageUX === "en" ? "Special Equipment" : "Special Equipment"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-324"
              inline={true}
              width={12}>
              <Dropdown
                id="CardORDetailUX-Dropdown-325"
                multiple={true}
                name="special_equipments"
                onChange={props.onChangeValue}
                options={props.specialEquipmentOptions || []}
                selection={true}
                style={{width: "100%"}}
                value={props.specialEquipments || []}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-9"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-108"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-112">
                {props.languageUX === "en" ? "Special Equipment detail" : "Special Equipment detail"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-109"
              inline={true}
              width={12}>
              <TextArea
                id="CardORDetailUX-TextArea-326"
                name="detail.special_equipments_detail"
                onChange={props.onChangeValue}
                value={props.detail?.special_equipments_detail || ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-11"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-113"
              inline={true}>
              <label
                id="CardORDetailUX-label-114">
                {props.languageUX === "en" ? "Additional Instructions" : "คำแนะนำในการปฏิบัติตัวเพิ่มเติม"}
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-120">
              <Button
                color="blue"
                id="CardORDetailUX-Button-121"
                onClick={props.onAddNote}>
                {props.languageUX === "en" ? "Add Instructions" : "เพิ่มคำแนะนำ"}
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-115"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-116"
              inline={true}
              width={16}>
              <TextArea
                id="CardORDetailUX-TextArea-117"
                name="remark"
                onChange={props.onChangeValue}
                rows={3}
                value={props.remarkDetail || ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-6"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-73"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-79">
                Anticipate Blood loss
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-74"
              inline={true}>
              <Radio
                checked={props.isLess_500 || false}
                id="CardORDetailUX-Radio-80"
                label=" < 500 ml in adult or < 7 ml/kg in children"
                name="anticipated_blood_loss.is_less_500"
                onChange={props.onChangeValue}>
              </Radio>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-75"
              inline={true}>
              <Radio
                checked={props.isMore_500 || false}
                id="CardORDetailUX-Radio-81"
                label=" > 500 ml in adult or > 7 ml/kg in children"
                name="anticipated_blood_loss.is_more_500"
                onChange={props.onChangeValue}>
              </Radio>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-76"
              inline={true}>
              <div
                id="CardORDetailUX-div-82">
                Define
              </div>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-77"
              inline={true}
              width={2}>
              <Input
                id="CardORDetailUX-Input-84"
                name="anticipated_blood_loss.define"
                onChange={props.onChangeValue}
                type="number"
                value={props.define || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-78"
              inline={true}>
              <div
                id="CardORDetailUX-div-83">
                mL
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-5"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-53"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-63">
                Blood Request
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-54"
              inline={true}
              width={2}>
              <Dropdown
                disabled={props.config?.showBloodRequest}
                fluid={true}
                id="CardORDetailUX-Dropdown-64"
                name="blood_request"
                onChange={props.onChangeValue}
                options={props.bloodRequestOptions || []}
                selection={true}
                style={{width: "100%"}}
                value={props.bloodRequest || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-55"
              inline={true}>
              <Button
                color="purple"
                disabled={!props.config?.showOrderBloodRequest && !props.canOrderBloodBank}
                id="CardORDetailUX-Button-145"
                onClick={props.onOrderBloodRequest}>
                {props.languageUX === "en" ? "Blood Order" : "สั่งจองเลือด"}
              </Button>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-327"
              inline={true}
              style={{ ...( props.bloodRequest !== "is_yes" && { display: "none" } ) }}>
              <Checkbox
                checked={props.is_blood_reserve}
                id="CardORDetailUX-Checkbox-328"
                label="สำรองเลือด (ไม่คิดค่าใช้จ่าย)"
                name="is_blood_reserve"
                onChange={props.onChangeValueBloodRequest}>
              </Checkbox>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-146"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-147"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-148"
                style={{display: props.config?.showBRCheck ? "": "none"}}>
                Blood Component
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-149"
              inline={true}
              width={7}>
              <Input
                id="CardORDetailUX-Input-165"
                name="blood_component"
                onChange={props.onChangeValueBloodRequest}
                readOnly={!props.is_blood_reserve}
                style={{display: props.config?.showBRCheck ? "": "none"}}
                value={props.blood_component}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-153"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-154"
              inline={true}
              width={2}>
              <label
                id="CardORDetailUX-label-155"
                style={{display: props.config?.showBRCheck ? "": "none"}}>
                นัดหมาย Cross-match
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-156"
              inline={true}
              width={3}>
              <Input
                id="CardORDetailUX-Input-166"
                readOnly={true}
                style={{display: props.config?.showBRCheck ? "": "none"}}
                value={props.cross_match_detail}>
              </Input>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-158"
              inline={true}>
              <label
                id="CardORDetailUX-label-164"
                style={{display: props.config?.showBRCheck ? "": "none"}}>
                วันเจาะเลือด
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-160"
              inline={true}
              width="3">
              <Input
                id="CardORDetailUX-Input-167"
                readOnly={true}
                style={{display: props.config?.showBRCheck ? "": "none"}}
                value={props.cross_match_date}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORDetailUX-FormGroup-250"
            inline={true}>
            <FormField
              id="CardORDetailUX-FormField-251"
              inline={true}
              width={4}>
              <label
                id="CardORDetailUX-label-252">
                Pre-Operative Medical Assessment
              </label>
            </FormField>
            <FormField
              id="CardORDetailUX-FormField-253"
              inline={true}
              width={3}>
              <Button
                color="orange"
                icon={true}
                id="CardORDetailUX-Button-255"
                labelPosition="left"
                onClick={props.onOpenModRisk}
                size="mini">
                Assessment Tool
                <Icon
                  id="CardORDetailUX-Icon-329"
                  name="check square outline">
                </Icon>
              </Button>
            </FormField>
          </FormGroup>
          <Segment
            id="CardORDetailUX-Segment-256">
            <FormGroup
              id="CardORDetailUX-FormGroup-257"
              inline={true}>
              <FormField
                id="CardORDetailUX-FormField-258"
                inline={true}>
                <label
                  id="CardORDetailUX-label-259">
                  Assessment: 
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardORDetailUX-FormGroup-260"
              inline={true}>
              <FormField
                id="CardORDetailUX-FormField-261"
                inline={true}
                width={4}>
                <label
                  id="CardORDetailUX-label-262"
                  style={{ fontWeight: "normal" }}>
                  1. Cardiovascular and Pulmonary
                </label>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-319"
                width={1}>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-263"
                inline={true}
                width={5}>
                <Dropdown
                  fluid={true}
                  id="CardORDetailUX-Dropdown-264"
                  name="pre_op_medical_assessment.data.cardiovascular"
                  onChange={props.onChangeValue}
                  options={props.preAssessmentOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%" }}
                  value={props.preOpMedicalAssessment?.data?.cardiovascular || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-266"
                inline={true}
                width={6}>
                <label
                  id="CardORDetailUX-label-267"
                  style={{ fontWeight: "normal" }}>
                  
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardORDetailUX-FormGroup-268"
              inline={true}>
              <FormField
                id="CardORDetailUX-FormField-269"
                inline={true}
                width={4}>
                <label
                  id="CardORDetailUX-label-270"
                  style={{ fontWeight: "normal" }}>
                   2. Risk of Bleeding
                </label>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-317"
                width={1}>
                <div
                  id="CardORDetailUX-div-315"
                  style={{ display: props.preOpMedicalAssessment?.data?.risk_bleeding?.edit_by ? "" : "none", textAlign: "right", width: "100%" }}>
                  
                  <Icon
                    color="green"
                    id="CardORDetailUX-Icon-314"
                    name="check square outline">
                  </Icon>
                </div>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-272"
                inline={true}
                width={5}>
                <Dropdown
                  clearable={true}
                  disabled={props.preOpMedicalAssessment?.data?.risk_bleeding?.summary}
                  fluid={true}
                  id="CardORDetailUX-Dropdown-292"
                  name="pre_op_medical_assessment.data.bleeding"
                  onChange={props.onChangeValue}
                  options={props.preAssessmentOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.preOpMedicalAssessment?.data?.risk_bleeding?.summary || props.preOpMedicalAssessment?.data?.bleeding || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-274"
                inline={true}
                width={6}>
                <label
                  id="CardORDetailUX-label-275"
                  style={{ fontWeight: "normal" }}>
                  {`${props.preOpMedicalAssessment?.data?.risk_bleeding?.edit_by || ""}    ${props.preOpMedicalAssessment?.data?.risk_bleeding?.edited || ""}`}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardORDetailUX-FormGroup-276"
              inline={true}>
              <FormField
                id="CardORDetailUX-FormField-277"
                inline={true}
                width={4}>
                <label
                  id="CardORDetailUX-label-278"
                  style={{ fontWeight: "normal" }}>
                   3. Risk of DVT
                </label>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-318"
                width={1}>
                <div
                  id="CardORDetailUX-div-316"
                  style={{ display: props.preOpMedicalAssessment?.data?.risk_dvt?.edit_by ? "" : "none", textAlign: "right", width: "100%" }}>
                  
                  <Icon
                    color="green"
                    id="CardORDetailUX-Icon-313"
                    name="check square outline">
                  </Icon>
                </div>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-280"
                inline={true}
                width={5}>
                <Dropdown
                  clearable={true}
                  disabled={props.preOpMedicalAssessment?.data?.risk_dvt?.summary}
                  fluid={true}
                  id="CardORDetailUX-Dropdown-293"
                  name="pre_op_medical_assessment.data.dvt"
                  onChange={props.onChangeValue}
                  options={props.preAssessmentOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.preOpMedicalAssessment?.data?.risk_dvt?.summary || props.preOpMedicalAssessment?.data?.dvt || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-282"
                inline={true}
                width={6}>
                <label
                  id="CardORDetailUX-label-283"
                  style={{ fontWeight: "normal" }}>
                  {`${props.preOpMedicalAssessment?.data?.risk_dvt?.edit_by || ""}    ${props.preOpMedicalAssessment?.data?.risk_dvt?.edited || ""}`}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardORDetailUX-FormGroup-284"
              inline={true}>
              <FormField
                id="CardORDetailUX-FormField-285"
                inline={true}
                width={4}>
                <label
                  id="CardORDetailUX-label-286"
                  style={{ fontWeight: "normal" }}>
                  4. ASA Classification
                </label>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-320"
                width={1}>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-288"
                inline={true}
                width={5}>
                <Input
                  disabled={true}
                  id="CardORDetailUX-Input-309"
                  value={props.asaClassText || ""}>
                </Input>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-290"
                inline={true}
                width={6}>
                <label
                  id="CardORDetailUX-label-291"
                  style={{ fontWeight: "normal" }}>
                  
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardORDetailUX-FormGroup-295"
              inline={true}>
              <FormField
                id="CardORDetailUX-FormField-296"
                inline={true}
                width={2}>
                <label
                  id="CardORDetailUX-label-297"
                  style={{ fontWeight: "normal" }}>
                  5. Co-mobidities
                </label>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-298"
                inline={true}
                width={11}>
                <TextArea
                  id="CardORDetailUX-TextArea-299"
                  name="pre_op_medical_assessment.data.co_mobidities"
                  onChange={props.onChangeValue}
                  rows={3}
                  value={props.preOpMedicalAssessment?.data?.co_mobidities || ""}>
                </TextArea>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardORDetailUX-FormGroup-300"
              inline={true}
              style={{ background: "rgba(117, 229, 255, 0.32)", padding: "10px", width: "300px" }}>
              <FormField
                id="CardORDetailUX-FormField-301"
                inline={true}>
                <label
                  id="CardORDetailUX-label-302">
                  Proceed with surgery
                </label>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-305"
                inline={true}>
                <Radio
                  checked={props.preOpMedicalAssessment?.data?.proceed_with_surgery === "yes"}
                  id="CardORDetailUX-Radio-306"
                  label="Yes"
                  name="data.proceed_with_surgery"
                  onChange={(e: any, v: any)=> props.onChangeValue(e, { value: "yes", name: "pre_op_medical_assessment.data.proceed_with_surgery" })}>
                </Radio>
              </FormField>
              <FormField
                id="CardORDetailUX-FormField-307"
                inline={true}>
                <Radio
                  checked={props.preOpMedicalAssessment?.data?.proceed_with_surgery === "no"}
                  id="CardORDetailUX-Radio-310"
                  label="No"
                  name="data.proceed_with_surgery"
                  onChange={(e: any, v: any)=> props.onChangeValue(e, { value: "no", name: "pre_op_medical_assessment.data.proceed_with_surgery" })}>
                </Radio>
              </FormField>
            </FormGroup>
          </Segment>
        </div>
      </div>
    )
}


export default CardORDetailUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Fri Oct 31 2025 04:20:17 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetail"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\",}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "วิธีระงับความรู้สึก",
          "valueEN": "Anesthesia Method"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-18"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: 0}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-19"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Dropdown",
      "parent": 13,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-20"
        },
        "name": {
          "type": "value",
          "value": "anesthesia_method"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.anesthesiaMethodOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.anesthesiaMethod || \"\""
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "label",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา เริ่มต้น",
          "valueEN": "Start time"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-36"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#056EBD\",minWidth: \"max-content\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartTime"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา สิ้นสุด",
          "valueEN": "End time"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#056EBD\", minWidth: \"max-content\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.EndTime"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.hideProcedureChecklist?\"none\":\"\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.hideProcedureChecklist?\"none\":\"\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทหัตถการ",
          "valueEN": "Procedure Type"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-49"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Dropdown",
      "parent": 46,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-50"
        },
        "name": {
          "type": "value",
          "value": "procedure_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.procedureTypeOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.procedureType || \"\""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Checkbox",
      "parent": 47,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.frozenSection || false"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Checkbox-51"
        },
        "label": {
          "type": "value",
          "value": "การตัดชิ้นเนื้อต่อมน้ำเหลืองหลัก & การตรวจชิ้นเนื้อแบบแช่เย็น",
          "valueEN": "Sentinel lymph node biopsy & Frozen section"
        },
        "name": {
          "type": "value",
          "value": "frozen_section"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Checkbox",
      "parent": 48,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.mammogram || false"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Checkbox-52"
        },
        "label": {
          "type": "value",
          "value": "การวางเข็มชี้ตำแหน่ง; ด้วยแมมโมแกรม",
          "valueEN": "Needle Localized; Mammogram"
        },
        "name": {
          "type": "value",
          "value": "mammogram"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-55"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "label",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": "Blood Request"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-63"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Dropdown",
      "parent": 54,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.config?.showBloodRequest"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-64"
        },
        "name": {
          "type": "value",
          "value": "blood_request"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.bloodRequestOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.bloodRequest || \"\""
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-73"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-74"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-75"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-76"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-77"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-78"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "label",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "Anticipate Blood loss"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-79"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "Radio",
      "parent": 74,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isLess_500 || false"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-80"
        },
        "label": {
          "type": "value",
          "value": " < 500 ml in adult or < 7 ml/kg in children"
        },
        "name": {
          "type": "value",
          "value": "anticipated_blood_loss.is_less_500"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Radio",
      "parent": 75,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isMore_500 || false"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-81"
        },
        "label": {
          "type": "value",
          "value": " > 500 ml in adult or > 7 ml/kg in children"
        },
        "name": {
          "type": "value",
          "value": "anticipated_blood_loss.is_more_500"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 76,
      "props": {
        "children": {
          "type": "value",
          "value": "Define"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-82"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "mL"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-83"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Input",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-84"
        },
        "name": {
          "type": "value",
          "value": "anticipated_blood_loss.define"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.define || \"\""
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 7,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{_minWidth: \"290px\",minWidth: \"max-content\",gap:\"10px\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-90"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-91"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "label",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "ยาที่ต้องหยุดก่อนผ่าตัด",
          "valueEN": "Preoperative medications to stop"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-92"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "Radio",
      "parent": 86,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.antiPlateletValue === props.ADM_FIBRINOLYTIC_USED.NO_DRUG"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-94"
        },
        "label": {
          "type": "value",
          "value": "ไม่ได้ใช้ยา",
          "valueEN": "Not on medication"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value:  props.ADM_FIBRINOLYTIC_USED.NO_DRUG, name: \"anti_platelet_coagulant.value\" })"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "label",
      "parent": 90,
      "props": {
        "children": {
          "type": "value",
          "value": "งดใช้ยาตั้งแต่วันที่",
          "valueEN": "Stop medication from"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-98"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxAntiPlatelet"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-99"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-100"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-101"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-102"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-103"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "label",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": "Contrast Media",
          "valueEN": "Contrast Media"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-104"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "label",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": "ASA PS",
          "valueEN": "ASA PS"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-105"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "Dropdown",
      "parent": 101,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-106"
        },
        "name": {
          "type": "value",
          "value": "contrast_media"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.cmOptions || {}"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.contrastMedia || \"\""
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "Dropdown",
      "parent": 103,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-107"
        },
        "name": {
          "type": "value",
          "value": "asa_class"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.asaClassOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.asaClass || \"\""
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-109"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "label",
      "parent": 108,
      "props": {
        "children": {
          "type": "value",
          "value": "Special Equipment detail",
          "valueEN": "Special Equipment detail"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-112"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-113"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "label",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "คำแนะนำในการปฏิบัติตัวเพิ่มเติม",
          "valueEN": "Additional Instructions"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-114"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-116"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "TextArea",
      "parent": 116,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-TextArea-117"
        },
        "name": {
          "type": "value",
          "value": "remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "rows": {
          "type": "code",
          "value": "3"
        },
        "value": {
          "type": "code",
          "value": "props.remarkDetail || \"\""
        }
      },
      "seq": 117,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-118"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-120"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "Button",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มคำแนะนำ",
          "valueEN": "Add Instructions"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Button-121"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddNote"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "FormField",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-123"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-125"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-128"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 206,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "Input",
      "parent": 123,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-132"
        },
        "name": {
          "type": "value",
          "value": "estimate_operation_hour"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"6rem\", maxWidth: \"6rem\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.estimateOperationHour || \"\""
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "Input",
      "parent": 125,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-133"
        },
        "name": {
          "type": "value",
          "value": "estimate_operation_minute"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"6rem\", maxWidth: \"6rem\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.estimateOperationMinute || \"\""
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 128,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-137"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-138"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-139"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "label",
      "parent": 137,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานที่",
          "valueEN": "Location"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-141"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#056EBD\"}"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "label",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": "ห้อง",
          "valueEN": "Room"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-142"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#056EBD\"}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "Dropdown",
      "parent": 140,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledRoom || props.config?.allowedEdit || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "code",
          "value": "null"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-143"
        },
        "name": {
          "type": "value",
          "value": "operating_room"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.operatingRoomOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", ...(props.operatingRoom === \"\" && { display: \"none\" } ) }"
        },
        "value": {
          "type": "code",
          "value": "props.operatingRoom || \"ไปเลือกที่วันเวลาผ่าตัด\""
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Dropdown",
      "parent": 138,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disableLocation || props.config?.allowedEdit || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "code",
          "value": "null"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-144"
        },
        "name": {
          "type": "value",
          "value": "location"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.orLocationOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", ...(props.location === \"\" && { display: \"none\" } ) }"
        },
        "value": {
          "type": "code",
          "value": "props.location || \"ไปเลือกที่วันเวลาผ่าตัด\""
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Button",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": "สั่งจองเลือด",
          "valueEN": "Blood Order"
        },
        "color": {
          "type": "value",
          "value": "purple"
        },
        "disabled": {
          "type": "code",
          "value": "!props.config?.showOrderBloodRequest && !props.canOrderBloodBank"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Button-145"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOrderBloodRequest"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-146"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "label",
      "parent": 147,
      "props": {
        "children": {
          "type": "value",
          "value": "Blood Component"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-148"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.showBRCheck ? \"\": \"none\"}"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-149"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-153"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-154"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "label",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": "นัดหมาย Cross-match"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-155"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.showBRCheck ? \"\": \"none\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-156"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-158"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-160"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "label",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเจาะเลือด"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-164"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.showBRCheck ? \"\": \"none\"}"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "Input",
      "parent": 149,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-165"
        },
        "name": {
          "type": "value",
          "value": "blood_component"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValueBloodRequest"
        },
        "readOnly": {
          "type": "code",
          "value": "!props.is_blood_reserve"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.showBRCheck ? \"\": \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.blood_component"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "Input",
      "parent": 156,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-166"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.showBRCheck ? \"\": \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.cross_match_detail"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "Input",
      "parent": 160,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-167"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.showBRCheck ? \"\": \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.cross_match_date"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-168"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 169,
      "name": "Radio",
      "parent": 86,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.antiPlateletValue === props.ADM_FIBRINOLYTIC_USED.CUT_DRUG"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-169"
        },
        "label": {
          "type": "value",
          "value": "ไม่ต้องงด",
          "valueEN": "No need to stop medication"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value:  props.ADM_FIBRINOLYTIC_USED.CUT_DRUG, name:\"anti_platelet_coagulant.value\"})"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "Radio",
      "parent": 86,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.antiPlateletValue === props.ADM_FIBRINOLYTIC_USED.ANTI_PALETELET"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-170"
        },
        "label": {
          "type": "value",
          "value": "งดใช้ยา",
          "valueEN": "Stop medication"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value:  props.ADM_FIBRINOLYTIC_USED.ANTI_PALETELET, name:\"anti_platelet_coagulant.value\"})"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "Checkbox",
      "parent": 168,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.antiPlateletCoagulant?.drug || false"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Checkbox-171"
        },
        "label": {
          "type": "value",
          "value": "Anti-Platelet/ Anti-Coagulant",
          "valueEN": "Anti-Platelet/ Anti-Coagulant"
        },
        "name": {
          "type": "value",
          "value": "anti_platelet_coagulant.drug"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(100% - -3rem)\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-172"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "FormField",
      "parent": 172,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-173"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "FormField",
      "parent": 172,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-174"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"290px\"}"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "FormField",
      "parent": 172,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-175"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{alignItems:\"baseline\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "label",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-176"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 177,
      "name": "Checkbox",
      "parent": 175,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.otherPreOpMeds?.value || false"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Checkbox-177"
        },
        "label": {
          "type": "value",
          "value": "ยาอื่นๆ"
        },
        "name": {
          "type": "value",
          "value": "other_pre_op_meds.value"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "Input",
      "parent": 168,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.antiPlateletCoagulant?.drug || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-178"
        },
        "name": {
          "type": "value",
          "value": "anti_platelet_coagulant.remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.remark || \"\""
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "TextArea",
      "parent": 175,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.otherPreOpMeds?.value"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-TextArea-179"
        },
        "name": {
          "type": "value",
          "value": "other_pre_op_meds.remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "rows": {
          "type": "code",
          "value": "2"
        },
        "value": {
          "type": "code",
          "value": "props.otherPreOpMeds?.remark || \"\""
        }
      },
      "seq": 179,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "FormField",
      "parent": 172,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-180"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "FormField",
      "parent": 172,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-181"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "label",
      "parent": 180,
      "props": {
        "children": {
          "type": "value",
          "value": "งดใช้ยาตั้งแต่วันที่"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-182"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 181,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxOtherDrug"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-183"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 184,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-184"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "FormField",
      "parent": 184,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-185"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-186"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-187"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-188"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "label",
      "parent": 185,
      "props": {
        "children": {
          "type": "value",
          "value": "NPO"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-189"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 190,
      "name": "Radio",
      "parent": 186,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.npoValue === props.NOTHING_THROUGH_MOUTH?.NO_NPO"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-190"
        },
        "label": {
          "type": "value",
          "value": "ไม่ต้อง NPO"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value:  props.NOTHING_THROUGH_MOUTH?.NO_NPO, name: \"npo.value\" })"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "Radio",
      "parent": 187,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.npoValue === props.NOTHING_THROUGH_MOUTH?.NPO_ALL"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-191"
        },
        "label": {
          "type": "value",
          "value": "NPO ทั้งหมด"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value:  props.NOTHING_THROUGH_MOUTH?.NPO_ALL, name: \"npo.value\" })"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 192,
      "name": "Radio",
      "parent": 188,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.npoValue === props.NOTHING_THROUGH_MOUTH?.EXCEPT_MEDS"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-192"
        },
        "label": {
          "type": "value",
          "value": "NPO ยกเว้น ยา"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value:  props.NOTHING_THROUGH_MOUTH?.EXCEPT_MEDS, name: \"npo.value\" })"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 193,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-193"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 194,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-194"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-195"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "FormField",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-196"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": null,
      "id": 197,
      "name": "label",
      "parent": 193,
      "props": {
        "children": {
          "type": "value",
          "value": "งดตั้งแต่วันที่"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-197"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": null,
      "id": 198,
      "name": "label",
      "parent": 195,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-198"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": null,
      "id": 199,
      "name": "div",
      "parent": 194,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxNPO"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-199"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": null,
      "id": 200,
      "name": "div",
      "parent": 196,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TimeNPO"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-200"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 201,
      "name": "Radio",
      "parent": 168,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.antiPlateletValue === props.ADM_FIBRINOLYTIC_USED.ANTI_PALETELET"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-201"
        },
        "label": {
          "type": "value",
          "value": "ใช้ Anti-Platelet/ Anti-Coagulant"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value:  props.ADM_FIBRINOLYTIC_USED.ANTI_PALETELET, name:\"anti_platelet_coagulant.value\"})"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", marginRight: \"1rem\", display: \"none\" }"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 203,
      "name": "label",
      "parent": 128,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ผ่าตัด",
          "valueEN": "Date of Surgery"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-203"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#056EBD\",width: \"100%\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 205,
      "name": "label",
      "parent": 125,
      "props": {
        "children": {
          "type": "value",
          "value": "นาที",
          "valueEN": "min"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-205"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\",color: \"#056EBD\", minWidth: \"max-content\" }"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": null,
      "id": 208,
      "name": "label",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": "ชั่วโมง",
          "valueEN": "hr."
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-208"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\",color: \"#056EBD\", marginLeft: \"0.75rem\", marginRight: \"1.25rem\"  }"
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 209,
      "name": "Input",
      "parent": 138,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-209"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", ...(props.location !== \"\" && { display: \"none\" } ) }"
        },
        "value": {
          "type": "value",
          "value": "ไปเลือกที่วันเวลาผ่าตัด"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 210,
      "name": "Input",
      "parent": 140,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-210"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", ...(props.operatingRoom !== \"\" && { display: \"none\" } ) }"
        },
        "value": {
          "type": "value",
          "value": "ไปเลือกที่วันเวลาผ่าตัด"
        }
      },
      "seq": 210,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 211,
      "name": "FormField",
      "parent": 123,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-211"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": null,
      "id": 212,
      "name": "label",
      "parent": 211,
      "props": {
        "children": {
          "type": "value",
          "value": "Estimate time",
          "valueEN": "Estimate time"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-212"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#056EBD\",}"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 213,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-213"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 214,
      "name": "FormField",
      "parent": 213,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-214"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "label",
      "parent": 214,
      "props": {
        "children": {
          "type": "value",
          "value": "NPO",
          "valueEN": "NPO"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-215"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 222,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-222"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 223,
      "name": "FormField",
      "parent": 222,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-223"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 225,
      "name": "FormField",
      "parent": 222,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-225"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{_minWidth: \"290px\",minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 229,
      "name": "FormField",
      "parent": 222,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-229"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 230,
      "name": "Checkbox",
      "parent": 229,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.antiPlateletCoagulant?.other_drug || false"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Checkbox-230"
        },
        "label": {
          "type": "value",
          "value": "ยาอื่น ๆ",
          "valueEN": "Other Medications"
        },
        "name": {
          "type": "value",
          "value": "anti_platelet_coagulant.other_drug"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(100% - -3rem)\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 233,
      "name": "FormField",
      "parent": 222,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-233"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": null,
      "id": 234,
      "name": "label",
      "parent": 233,
      "props": {
        "children": {
          "type": "value",
          "value": "งดใช้ยาตั้งแต่วันที่",
          "valueEN": "Stop medication from"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-234"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 235,
      "name": "FormField",
      "parent": 222,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-235"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": null,
      "id": 236,
      "name": "div",
      "parent": 235,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxAntiPlateletOther"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-236"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 237,
      "name": "TextArea",
      "parent": 229,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.antiPlateletCoagulant?.other_drug || false"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-TextArea-237"
        },
        "name": {
          "type": "value",
          "value": "anti_platelet_coagulant.other_drug_remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.antiPlateletCoagulant?.other_drug_remark || \"\""
        }
      },
      "seq": 237,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 238,
      "name": "FormField",
      "parent": 213,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-238"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{_minWidth: \"290px\",minWidth: \"max-content\", gap:\"10px\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 239,
      "name": "Radio",
      "parent": 238,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.antiPlateletCoagulant?.npo === \"NO_NPO\""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-239"
        },
        "label": {
          "type": "value",
          "value": "ไม่ต้อง NPO",
          "valueEN": "No NPO required"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value: \"NO_NPO\", name: \"anti_platelet_coagulant.npo\" })"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 240,
      "name": "Radio",
      "parent": 238,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.antiPlateletCoagulant?.npo === \"NPO\""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-240"
        },
        "label": {
          "type": "value",
          "value": "NPO ทั้งหมด",
          "valueEN": "Full NPO"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value: \"NPO\", name: \"anti_platelet_coagulant.npo\" })"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 241,
      "name": "Radio",
      "parent": 238,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.antiPlateletCoagulant?.npo === \"NO_NPO_DRUG\""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-241"
        },
        "label": {
          "type": "value",
          "value": "NPO ยกเว้น ยา",
          "valueEN": "NPO except medications"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value: \"NO_NPO_DRUG\", name: \"anti_platelet_coagulant.npo\" })"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 242,
      "name": "FormField",
      "parent": 213,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-242"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 243,
      "name": "label",
      "parent": 242,
      "props": {
        "children": {
          "type": "value",
          "value": "งดตั้งแต่วันที่",
          "valueEN": "Stop from"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-243"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 244,
      "name": "FormField",
      "parent": 213,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-244"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": null,
      "id": 245,
      "name": "div",
      "parent": 244,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DateTextBoxNPO"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-245"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 246,
      "name": "FormField",
      "parent": 213,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-246"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 247,
      "name": "label",
      "parent": 246,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "Time"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-247"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 248,
      "name": "FormField",
      "parent": 213,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-248"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": null,
      "id": 249,
      "name": "div",
      "parent": 248,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TimeTextBoxNPO"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-249"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 250,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-250"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 251,
      "name": "FormField",
      "parent": 250,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-251"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "label",
      "parent": 251,
      "props": {
        "children": {
          "type": "value",
          "value": "Pre-Operative Medical Assessment"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-252"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 253,
      "name": "FormField",
      "parent": 250,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-253"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 255,
      "name": "Button",
      "parent": 253,
      "props": {
        "children": {
          "type": "value",
          "value": "Assessment Tool"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Button-255"
        },
        "labelPosition": {
          "type": "value",
          "value": "left"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenModRisk"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 256,
      "name": "Segment",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Segment-256"
        }
      },
      "seq": 321,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 257,
      "name": "FormGroup",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-257"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 258,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-258"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 259,
      "name": "label",
      "parent": 258,
      "props": {
        "children": {
          "type": "value",
          "value": "Assessment: "
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-259"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 260,
      "name": "FormGroup",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-260"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 261,
      "name": "FormField",
      "parent": 260,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-261"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 262,
      "name": "label",
      "parent": 261,
      "props": {
        "children": {
          "type": "value",
          "value": "1. Cardiovascular and Pulmonary"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-262"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 263,
      "name": "FormField",
      "parent": 260,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-263"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 264,
      "name": "Dropdown",
      "parent": 263,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-264"
        },
        "name": {
          "type": "value",
          "value": "pre_op_medical_assessment.data.cardiovascular"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.preAssessmentOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.preOpMedicalAssessment?.data?.cardiovascular || \"\""
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 266,
      "name": "FormField",
      "parent": 260,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-266"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 319,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "label",
      "parent": 266,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-267"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 268,
      "name": "FormGroup",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-268"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 269,
      "name": "FormField",
      "parent": 268,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-269"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": null,
      "id": 270,
      "name": "label",
      "parent": 269,
      "props": {
        "children": {
          "type": "value",
          "value": " 2. Risk of Bleeding"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-270"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 270,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 272,
      "name": "FormField",
      "parent": 268,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-272"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 274,
      "name": "FormField",
      "parent": 268,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-274"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 317,
      "void": false
    },
    {
      "from": null,
      "id": 275,
      "name": "label",
      "parent": 274,
      "props": {
        "children": {
          "type": "code",
          "value": "`${props.preOpMedicalAssessment?.data?.risk_bleeding?.edit_by || \"\"}    ${props.preOpMedicalAssessment?.data?.risk_bleeding?.edited || \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-275"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 276,
      "name": "FormGroup",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-276"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 277,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-277"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": null,
      "id": 278,
      "name": "label",
      "parent": 277,
      "props": {
        "children": {
          "type": "value",
          "value": " 3. Risk of DVT"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-278"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 280,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-280"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 282,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-282"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 318,
      "void": false
    },
    {
      "from": null,
      "id": 283,
      "name": "label",
      "parent": 282,
      "props": {
        "children": {
          "type": "code",
          "value": "`${props.preOpMedicalAssessment?.data?.risk_dvt?.edit_by || \"\"}    ${props.preOpMedicalAssessment?.data?.risk_dvt?.edited || \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-283"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 284,
      "name": "FormGroup",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-284"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 285,
      "name": "FormField",
      "parent": 284,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-285"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": null,
      "id": 286,
      "name": "label",
      "parent": 285,
      "props": {
        "children": {
          "type": "value",
          "value": "4. ASA Classification"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-286"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 288,
      "name": "FormField",
      "parent": 284,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-288"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 290,
      "name": "FormField",
      "parent": 284,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-290"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 320,
      "void": false
    },
    {
      "from": null,
      "id": 291,
      "name": "label",
      "parent": 290,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-291"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 292,
      "name": "Dropdown",
      "parent": 272,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.preOpMedicalAssessment?.data?.risk_bleeding?.summary"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-292"
        },
        "name": {
          "type": "value",
          "value": "pre_op_medical_assessment.data.bleeding"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.preAssessmentOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.preOpMedicalAssessment?.data?.risk_bleeding?.summary || props.preOpMedicalAssessment?.data?.bleeding || \"\""
        }
      },
      "seq": 315,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 293,
      "name": "Dropdown",
      "parent": 280,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.preOpMedicalAssessment?.data?.risk_dvt?.summary"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-293"
        },
        "name": {
          "type": "value",
          "value": "pre_op_medical_assessment.data.dvt"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.preAssessmentOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.preOpMedicalAssessment?.data?.risk_dvt?.summary || props.preOpMedicalAssessment?.data?.dvt || \"\""
        }
      },
      "seq": 316,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 295,
      "name": "FormGroup",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-295"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 295,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 296,
      "name": "FormField",
      "parent": 295,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-296"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 296,
      "void": false
    },
    {
      "from": null,
      "id": 297,
      "name": "label",
      "parent": 296,
      "props": {
        "children": {
          "type": "value",
          "value": "5. Co-mobidities"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-297"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 297,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 298,
      "name": "FormField",
      "parent": 295,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-298"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "11"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 299,
      "name": "TextArea",
      "parent": 298,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-TextArea-299"
        },
        "name": {
          "type": "value",
          "value": "pre_op_medical_assessment.data.co_mobidities"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "rows": {
          "type": "code",
          "value": "3"
        },
        "value": {
          "type": "code",
          "value": "props.preOpMedicalAssessment?.data?.co_mobidities || \"\""
        }
      },
      "seq": 299,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 300,
      "name": "FormGroup",
      "parent": 256,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-300"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"rgba(117, 229, 255, 0.32)\", padding: \"10px\", width: \"300px\" }"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 301,
      "name": "FormField",
      "parent": 300,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-301"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": null,
      "id": 302,
      "name": "label",
      "parent": 301,
      "props": {
        "children": {
          "type": "value",
          "value": "Proceed with surgery"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-302"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 302,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 305,
      "name": "FormField",
      "parent": 300,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-305"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 305,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 306,
      "name": "Radio",
      "parent": 305,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.preOpMedicalAssessment?.data?.proceed_with_surgery === \"yes\""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-306"
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "name": {
          "type": "value",
          "value": "data.proceed_with_surgery"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value: \"yes\", name: \"pre_op_medical_assessment.data.proceed_with_surgery\" })"
        },
        "value": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 306,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 307,
      "name": "FormField",
      "parent": 300,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-307"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 307,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 309,
      "name": "Input",
      "parent": 288,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Input-309"
        },
        "readOnly": {
          "type": "value",
          "value": ""
        },
        "readonly": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.asaClassText || \"\""
        }
      },
      "seq": 309,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 310,
      "name": "Radio",
      "parent": 307,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.preOpMedicalAssessment?.data?.proceed_with_surgery === \"no\""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Radio-310"
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "name": {
          "type": "value",
          "value": "data.proceed_with_surgery"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any, v: any)=> props.onChangeValue(e, { value: \"no\", name: \"pre_op_medical_assessment.data.proceed_with_surgery\" })"
        },
        "value": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 310,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 313,
      "name": "Icon",
      "parent": 316,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Icon-313"
        },
        "name": {
          "type": "value",
          "value": "check square outline"
        }
      },
      "seq": 293,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 314,
      "name": "Icon",
      "parent": 315,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Icon-314"
        },
        "name": {
          "type": "value",
          "value": "check square outline"
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": null,
      "id": 315,
      "name": "div",
      "parent": 317,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-315"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.preOpMedicalAssessment?.data?.risk_bleeding?.edit_by ? \"\" : \"none\", textAlign: \"right\", width: \"100%\" }"
        }
      },
      "seq": 314,
      "void": false
    },
    {
      "from": null,
      "id": 316,
      "name": "div",
      "parent": 318,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-div-316"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.preOpMedicalAssessment?.data?.risk_dvt?.edit_by ? \"\" : \"none\", textAlign: \"right\", width: \"100%\" }"
        }
      },
      "seq": 313,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 317,
      "name": "FormField",
      "parent": 268,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-317"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 318,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-318"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 319,
      "name": "FormField",
      "parent": 260,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-319"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 320,
      "name": "FormField",
      "parent": 284,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-320"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 321,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormGroup-321"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 322,
      "name": "FormField",
      "parent": 321,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-322"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 322,
      "void": false
    },
    {
      "from": null,
      "id": 323,
      "name": "label",
      "parent": 322,
      "props": {
        "children": {
          "type": "value",
          "value": "Special Equipment",
          "valueEN": "Special Equipment"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-label-323"
        }
      },
      "seq": 323,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 324,
      "name": "FormField",
      "parent": 321,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-324"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 324,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 325,
      "name": "Dropdown",
      "parent": 324,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Dropdown-325"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "special_equipments"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.specialEquipmentOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.specialEquipments || []"
        }
      },
      "seq": 325,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 326,
      "name": "TextArea",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-TextArea-326"
        },
        "name": {
          "type": "value",
          "value": "detail.special_equipments_detail"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.special_equipments_detail || \"\""
        }
      },
      "seq": 326,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 327,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-FormField-327"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...( props.bloodRequest !== \"is_yes\" && { display: \"none\" } ) }"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 327,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 328,
      "name": "Checkbox",
      "parent": 327,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.is_blood_reserve"
        },
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Checkbox-328"
        },
        "label": {
          "type": "value",
          "value": "สำรองเลือด (ไม่คิดค่าใช้จ่าย)"
        },
        "name": {
          "type": "value",
          "value": "is_blood_reserve"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValueBloodRequest"
        }
      },
      "seq": 328,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 329,
      "name": "Icon",
      "parent": 255,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORDetailUX-Icon-329"
        },
        "name": {
          "type": "value",
          "value": "check square outline"
        }
      },
      "seq": 329,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardORDetailUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
